import React from "react";

import * as Styled from "./styles";

import { Button } from "@mui/material";

import { IoIosArrowForward } from "react-icons/io";

import { IoIosArrowBack } from "react-icons/io";

import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";

interface IProps {
  pageNow: number;
  onNextPage?: () => void;
  onPrevPage?: () => void;
  totalPages?: number;
  loading?: boolean;
  onFirstPage?: () => void;
  onLastPage?: () => void;
}

const Paginate: React.FC<IProps> = ({
  pageNow,
  onNextPage,
  onPrevPage,
  totalPages,
  onFirstPage,
  onLastPage,
}) => {
  return (
    <Styled.Container>
      <Button disabled={pageNow === 1} onClick={onFirstPage}>
        <FaAngleDoubleLeft size={25} />
      </Button>

      <Button disabled={pageNow === 1} onClick={onPrevPage}>
        <IoIosArrowBack size={25} />
      </Button>

      <Styled.BoxNumbers>
        <div>
          {pageNow && pageNow > 1 && (
            <Styled.ItemAround onClick={onPrevPage}>
              {pageNow && pageNow - 1}
            </Styled.ItemAround>
          )}
        </div>
        <div>
          <Styled.ItemFocus>{pageNow}</Styled.ItemFocus>
        </div>
        <div>
          {totalPages === 1 ? (
            ""
          ) : pageNow && pageNow === totalPages ? (
            ""
          ) : (
            <Styled.ItemAround onClick={onNextPage}>
              {pageNow && pageNow + 1}
            </Styled.ItemAround>
          )}
        </div>
      </Styled.BoxNumbers>

      <Button
        onClick={onNextPage}
        disabled={pageNow && totalPages && totalPages > pageNow ? false : true}
      >
        <IoIosArrowForward size={25} />
      </Button>

      <Button
        disabled={pageNow && totalPages && totalPages > pageNow ? false : true}
        onClick={onLastPage}
      >
        <FaAngleDoubleRight size={25} />
      </Button>
    </Styled.Container>
  );
};

export { Paginate };
